import React, { useState } from 'react';

const PagamentoPage = () => {
  const [email, setEmail] = useState('');
  const [descricao, setDescricao] = useState('');
  const [valor, setValor] = useState('');

  const handleAssinar = async () => {
    const res = await fetch('http://localhost:5000/criar-assinatura', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, descricao, valor })
    });

    const data = await res.json();
    if (data && data.init_point) {
      window.open(data.init_point, '_blank');  // link da assinatura
    } else {
      alert('Erro ao gerar link de assinatura.');
    }
  };


  return (
    <div style={{
      maxWidth: '400px',
      margin: '40px auto',
      padding: '20px',
      border: '1px solid #ccc',
      borderRadius: '8px',
      fontFamily: 'sans-serif'
    }}>
      <h2 style={{ textAlign: 'center' }}>Gerar Pagamento</h2>
      <div style={{ marginBottom: '12px' }}>
        <label>Email do cliente</label>
        <input
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          placeholder="cliente@email.com"
          style={{ width: '100%', padding: '8px', marginTop: '4px' }}
        />
      </div>
      <div style={{ marginBottom: '12px' }}>
        <label>Descrição do Serviço</label>
        <input
          type="text"
          value={descricao}
          onChange={e => setDescricao(e.target.value)}
          placeholder="Ex: Consulta básica"
          style={{ width: '100%', padding: '8px', marginTop: '4px' }}
        />
      </div>
      <div style={{ marginBottom: '20px' }}>
        <label>Valor (R$)</label>
        <input
          type="number"
          value={valor}
          onChange={e => setValor(e.target.value)}
          placeholder="Ex: 49.90"
          style={{ width: '100%', padding: '8px', marginTop: '4px' }}
        />
      </div>
      <button
        onClick={handleAssinar}
        style={{
          width: '100%',
          padding: '10px',
          backgroundColor: '#007bff',
          color: '#fff',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
      >
        Criar Assinatura
      </button>
    </div>
  );
};

export default PagamentoPage;
